import React, { Component } from 'react';

import './Footer.scss';

class Footer extends Component {
  render() {
    return (
      <div id="footer">
        <div className="footer_banner ">
          <div className="esc_container esc_container--xxl esc_box--around">
            <ul className="footer_list">
              <li className="footer_list_item">
                <a className="footer_item" href="https://www.ergo.de/de/Service/Datenschutz" target="_blank" rel="noopener noreferrer">Datenschutz</a>
              </li>
              <li className="footer_list_item">
                <a className="footer_item" href="https://www.ergo.de/de/Service/Kontakt/Allgemeine-Kontaktdaten" target="_blank" rel="noopener noreferrer">Kontakt</a>
              </li>
              <li className="footer_list_item">
                <a className="footer_item" href="https://www.ergo.de/de/Service/Anbieter" target="_blank" rel="noopener noreferrer">Impressum/Erstinformationen</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer;
